import React from 'react';
import { StyledButton } from '../styles/Button.styled';
import {
  Name,
  StyledButtonsContainer,
  StyledHome,
  Title,
  Line,
  Greeting,
  Social,
  Socials,
  Quote,
  Description,
} from '../styles/Home.styled';
import './style.css';
import projectIcon from '../../assets/icons/project-icon.svg';
import aboutIcon from '../../assets/icons/about-me.svg';
import { IconContext } from 'react-icons';
import { GrLinkedinOption } from 'react-icons/gr';
import { GoMarkGithub } from 'react-icons/go';
import { FaEnvelope } from 'react-icons/fa';

const Home = () => {
  let today = new Date(),
    hour = today.getHours();

  return (
    <IconContext.Provider value={{ size: '1rem' }}>
      <StyledHome id="home">
        <Name>Vasanth Prabhakaran</Name>
        <Title>Full-stack Developer</Title>
        <Description>
          I <span className="change-text"></span>{' '}
          <span className="responsive">r</span>
          <span className="responsive">e</span>
          <span className="responsive">s</span>
          <span className="responsive">p</span>
          <span className="responsive">o</span>
          <span className="responsive">n</span>
          <span className="responsive">s</span>
          <span className="responsive">i</span>
          <span className="responsive">v</span>
          <span className="responsive">e</span> websites and web applications.
        </Description>
        <StyledButtonsContainer>
          <StyledButton
            icon={projectIcon}
            to="projects"
            smooth={true}
            duration={0}
            delay={0}
            spy={true}
            spyThrottle={0}
            exact="true"
            offset={-50}
          >
            <span>Projects</span>
          </StyledButton>
          <StyledButton
            icon={aboutIcon}
            secondary="true"
            content="B"
            to="about"
            smooth={true}
            duration={0}
            delay={0}
            spy={true}
            spyThrottle={0}
            exact="true"
            offset={-50}
          >
            <span>About me</span>
          </StyledButton>
        </StyledButtonsContainer>
        <Line />
        <Greeting>
          have a wonderful
          <span>
            {hour < 12
              ? ' morning'
              : hour < 16
              ? ' afternoon'
              : hour < 20
              ? ' evening'
              : ' night'}
          </span>
          .
        </Greeting>
        <Socials>
          <Social
            href="mailto:vasanthprabhakaran1999@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaEnvelope />
          </Social>
          <Social
            href="https://github.com/Vasanth1009"
            target="_blank"
            rel="noopener noreferrer"
          >
            <GoMarkGithub />
          </Social>
          <Social
            href="https://www.linkedin.com/in/vasanthprabhakaran/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <GrLinkedinOption />
          </Social>
        </Socials>
        <Quote>Nothing worth having comes easy.</Quote>
      </StyledHome>
    </IconContext.Provider>
  );
};

export default Home;
